import { useDataMode } from '@/providers/DataModeProvider';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Database, TestTube } from 'lucide-react';

export function DataModeToggle() {
  const { dataMode, setDataMode } = useDataMode();

  return (
    <div className="flex items-center gap-2 ml-auto">
      <div className="flex items-center gap-2 text-sm">
        <TestTube className="h-4 w-4 text-muted-foreground" />
        <Label 
          htmlFor="data-mode-toggle" 
          className="text-sm font-normal cursor-pointer text-muted-foreground"
        >
          Demo
        </Label>
      </div>
      <Switch
        id="data-mode-toggle"
        checked={dataMode === 'live'}
        onCheckedChange={(checked) => setDataMode(checked ? 'live' : 'demo')}
      />
      <div className="flex items-center gap-2 text-sm">
        <Label 
          htmlFor="data-mode-toggle" 
          className="text-sm font-normal cursor-pointer text-muted-foreground"
        >
          Live
        </Label>
        <Database className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  );
}
